
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {FaqModel} from '@/models/faq.model';
  import {challengeModule, faqModule, faqsState} from '@/utils/store-acessor';
  import {ChallengeModel} from '@/models/challenge.model';

  @Component({})
  export default class ChallengeFaq extends Vue {
    @faqModule.Getter('faqs') faqs!: FaqModel[];
    @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel;

    mounted() {
      if (this.challenge?.id) {
        faqsState.fetchFaqs(this.challenge.id)
      }
    }
  }
